/**
 * Worker-safe JWT payload decoding.
 *
 * Pure — no imports from api clients, storage, or the DOM — so it can be
 * used from both the main thread and Web Workers (e.g. src/workers/token.ts).
 */

export function decodeJwtPayload(token: string): Record<string, unknown> {
    const encoded = token.split('.')[1]
    if (!encoded) throw new Error('Invalid JWT')
    const normalized = encoded.replace(/-/g, '+').replace(/_/g, '/')
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=')
    const bytes = Uint8Array.from(atob(padded), (char) => char.charCodeAt(0))
    return JSON.parse(new TextDecoder().decode(bytes)) as Record<
        string,
        unknown
    >
}

export function getJwtExpiry(token: string): number {
    try {
        const payload = decodeJwtPayload(token)
        const exp = parseInt(String(payload['exp']), 10)
        return Number.isFinite(exp) ? exp : 0
    } catch {
        return 0
    }
}
